// extracted by mini-css-extract-plugin
module.exports = {"parent":"Team_parent__3gzEZ","airTeam":"Team_airTeam__sl7YU","members":"Team_members__30B0_"};